import { render, staticRenderFns } from "./ModalTableQuick10.vue?vue&type=template&id=61c0957b&"
import script from "./ModalTableQuick10.vue?vue&type=script&lang=js&"
export * from "./ModalTableQuick10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports